import { camelize } from "humps";

export default {
  methods: {
    setErrors(errors) {
      Object.values(errors.response.data.errors).forEach(value => {
        const error = value.detail[0];
        const field = camelize(error.field);
        this.form[field].$dirty = true;
        this.form.$errors[field].required = error.detail;
      });
    }
  }
};
